(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('shortageRiskScoreCustomerConfig', shortageRiskScoreCustomerConfig);

	shortageRiskScoreCustomerConfig.$inject = ['$rootScope', '$scope', '$timeout', 'storeService'];

	function shortageRiskScoreCustomerConfig($rootScope, $scope, $timeout, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;

		vm.showAddRiskCategory = true;

		$scope.type = 'customer';
		$scope.siteId = adminConfig.factory.id;
		$scope.customerId = adminConfig.customer.id;
	}
})();